import { SET_BILLERS_LIST } from '../utils/constants'

export const setBillersList = (payload) => ({ type: SET_BILLERS_LIST, payload })
